<template>
  <div>
    <div class="m-background m-background--media-1"></div>
    <img class="leap" src="../../assets/images/logos/leap-skills-black.png" />
    <div class="l-container l-pad">
      <img src="../../assets/images/logos/logo__unite.png" class="unite-logo" />
      <div class="l__form">
        <h4 class="l__splash" style="margin-bottom:0;">
          Tell us a bit about you&nbsp;
          <span>
            <a class="tooltip">
              <img src="../../assets/images/btns/pos-question.png" />
              <span class="privacy"
                >By entering your details, you are confirming that you are happy
                for Unite Students to contact you with similar resources in
                future. All information collected will be used solely for the
                purpose(s) for which it is intended, in accordance with our
                <a href="https://www.unitestudents.com/terms/privacy-policy"
                  >Privacy Policy</a
                >. If you wish to withdraw this consent at any point, please
                contact
                <a href="mailto:leapskills@unitestudents.com"
                  >leapskills@unitestudents.com</a
                ></span
              ></a
            ></span
          >
        </h4>
        <p style="margin:0 0 0.2rem 0;">Please complete all fields</p>
        <form id="userForm">
          <p class="errors" v-if="errors.length">
            <strong>Please correct the following error(s):</strong>
            <span v-for="error in errors" :key="error">{{ error }}. </span>
          </p>
          <p>
            <label for="teacher-name">Name: </label
            ><input
              v-model="userName"
              type="text"
              id="userName"
              name="userName"
            />
          </p>
          <p>
            <label for="school-name">Organisation: </label
            ><input
              v-model="schoolName"
              type="text"
              id="schoolName"
              name="schoolName"
            />
          </p>
          <p>
            <label for="email-address">Email address: </label
            ><input
              v-model="emailAddress"
              type="email"
              id="emailAddress"
              name="emailAddress"
            /><br />
            <span class="emailInfo"
              >Please ensure details are entered correctly as the lesson
              facilitation pack and accompanying activities will be sent via
              email after registration.</span
            >
          </p>
          <a
            class="m-btn m-btn--left m-btn__primary"
            @click="updateUser(userName, schoolName, emailAddress)"
            >Continue &nbsp;<span
              class="m-btn__arrow"
              style="display:inline-block; margin-top: -0.4em;"
            ></span
          ></a>
          <router-link
            class="m-btn m-btn--right m-btn__secondary"
            :to="{ name: 'who' }"
            >&nbsp; Back<span
              class="m-btn__back"
              style="display:inline-block; margin-top: -0.4em;"
            ></span
          ></router-link>
        </form>
      </div>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MainFooter from '../../components/MainFooter'
export default {
  data () {
    return {
      errors: [],
      userName: '',
      schoolName: '',
      emailAddress: ''
    }
  },
  computed: {
    ...mapGetters({
      userData: 'getUserData'
    })
  },
  mounted () {
    this.userName = this.userData.userName
    this.schoolName = this.userData.schoolName
    this.emailAddress = this.userData.emailAddress
  },
  methods: {
    ...mapActions(['saveUser']),
    async updateUser (userName, schoolName, emailAddress) {
      this.errors = []

      if (!this.userName) {
        this.errors.push('Name required')
      }
      if (!this.schoolName) {
        this.errors.push('Organisation required')
      }
      if (!this.emailAddress) {
        this.errors.push('Email required')
      } else if (!this.validEmail(this.emailAddress)) {
        this.errors.push('Valid email required')
      }

      if (!this.errors.length) {
        // return true;
        this.saveUser({ userName, emailAddress, schoolName })
        this.$router.push({ name: 'start' })
      }
    },
    validEmail (emailAddress) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(emailAddress)
    }
  },
  components: {
    MainFooter
  },
  name: 'TeacherDetails'
}
</script>

<style scoped lang="scss">
img.l--right {
  width: 80%;
  right: -40px;
  bottom: -1px;
}

img.leap {
  width: 150px;
  height: auto;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 125px;
}
.unite-logo {
  width: 250px;
}

form p {
  margin-bottom: 20px;
}
form p.errors {
  width: 80%;
  color: #cc0000;
}

input {
  padding: 8px;
  width: 60%;
  border: none;
}
h4 {
  margin-bottom: 25px;
  position: relative;
}
.m-btn--right {
  bottom: 0;
  right: 0;
  padding: 10px 20px 5px 10px;
  font-size: 120%;
}
.m-btn__back {
  height: 25px;
  width: 19px;
  background-size: 90%;
  margin: 0px 0 0 20px;
  padding: 10px 0 0 0;
}
@media (min-width: 900px) {
  .l__splash {
    width: 60%;
  }
}
@media (max-width: 899px) {
  img.leap {
    width: 70px;
    height: auto;
    position: absolute;
    top: 10px;
    right: 20px;
  }
  .unite-logo {
    width: 15%;
  }
  .l__splash {
    width: 100%;
    font-size: 1.6rem;
  }
  form {
    margin-top: 5px;
    margin: 0 auto;
  }
  form p {
    margin-bottom: 5px;
  }

  input {
    padding: 3px;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Survey/TeacherDetails.vue